import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './nlp/imageclassify.css';
import bulk from './nlp/imageclassify.js';
import './panel.css';
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function error( s ) {
    var err = $('<div role="alert" class="fade alert alert-danger show">').html(s);
	$('.maincontent').html('').append(err);
}


var descriptor = {
	"labels": [
		{
			"label": "Some Label"
		}
	],
	"dataset": [
		{
			"imageUrl": "https://hddesktopwallpapers.in/wp-content/uploads/2015/09/toucan-bird.jpg",
			"label": "Toucan",
			"metadata": {
				"hello": "world",
				"situation": "nature",
				"tags": [
					"some",
					"test"
				]
			},
			"fileId": "09a634648e99fcba16b1fd235a390983",
			"classification": "Neutrophil",
			"selected": true,
		}
	],
	"imageLayout": {
		"showLabels": true,
		"showDetails": true,
		"showControls": false
	},
	"detailLayout": {
		"policy": "doubleclick",
		"doubleSize": 2,
		"showLabels": true,
		"showDetails": true,
		"showControls": false
	},
	"imageControls": {
		"redAdjust": true,
		"greenAdjust": true,
		"blueAdjust": false,
		"brigtnessAdjust": true
	},
	"gridLayout": {
		"imageZoom": 8,
		"itemsPerPage": 40,
		"filter": {
			"globalFilter": true,
			"keyFilter": true,
			"annotation": true
		},
		// "toggleLabels": true,
		"toggleDetails": true,
		"toggleControls": true
	},
	"userRole": {
		"role": "nlp_an"
	},
	"classificationMode": true,
	"selectionMode": "multi"
}


var global = window.GlobalVars;
var tasks = null;
var project = null;

function BulkClassify(prop) {

    var global = window.GlobalVars;
    var tab;

	descriptor.gridLayout.rolloverPreview = true;

    function start() {
        var projectId = global.bulkObject.project;
		var tasks = global.bulkObject.fileIds;
		descriptor.userRole.role = global.bulkObject.role;
		descriptor.userRole.email = global.userEmail;
		descriptor.bulkProject = global.bulkObject.project;
		frm.loading('Loading Tasks');
		descriptor.presignedConfig = {project:projectId};

		var match = {project:projectId, fileId:{$in:tasks}};
		descriptor.baseMatch = {type:'project',key:'fileId',match:match};
		console.log( 'baseMatch', descriptor.baseMatch );

		var getSize = 200000;
		var getSize = 1000;
		var updating = false;
		// descriptor.updating = function( val ) {
		// 	// alert('updating '+val)
		// 	updating = val;
		// }
		descriptor.progressiveLoad = function (config, callback) {
			if( descriptor.updating > 0 ) {
				console.log( 'WAIT')
				return setTimeout( function(){
					descriptor.progressiveLoad( config, callback );
				}, 250 )
			}
			var start = config.start;
			var filter = config.filter;
			var end = config.end || 0;
			var limit = end > 0 ? end - start + 1 : getSize;
			if (!filter) filter = {};
			frm.loading('Loading Tasks');
			var gmatch = clone(descriptor.baseMatch.match);
			if (Object.keys(filter).length) gmatch.filter = filter;
			gmatch._start = start;
			gmatch._limit = limit;
			console.log('GMATCH', JSON.stringify(gmatch))
			window.post('bulk_tasks', { bulkProject: projectId, match: gmatch }, res => {
				$('#pageTitle').html( 'Project: '+res.data.projectName )
				descriptor.filterData = res.data.filter;
				// console.log('bulk_tasks', descriptor.filterData );
				res.data.records = res.data.tasks;
				if (res.data.start == 0) {
					descriptor.dataset = [];
					descriptor.dataset[res.data.count - 1] = null;
				}

				descriptor.labels = [];
				for( var k in res.data.labels ) {
					var l = res.data.labels[k]
					descriptor.labels.push({ label: l.name || k });
				}
				// console.log( 'descriptor', descriptor )
				if( res.data.training ) {
					descriptor.qualificationMode = res.data.training.type;
					descriptor.qualificationFiles = res.data.training.files;
					if( descriptor.qualificationMode == 3 ) {
						descriptor.gridLayout.toggleDetails = descriptor.imageLayout.showDetails = false;
					}
				}
				if( res.data.bookmarkURL ) {
					descriptor.bookmarkURL = res.data.bookmarkURL;
				}
				descriptor.acknowledge = res.data.acknowledge || {};
				descriptor.acknowledgeKey = projectId;

				for (var i = 0; i < res.data.records.length; i++)
					descriptor.dataset[i + start] = res.data.records[i];
				if (descriptor.dataset.length == 0 && !Object.keys(filter).length) {
					frm.loadingOut();
					error('No documents found')
					return callback(res.data.records);
				}
				frm.loadingOut();
				callback(res.data.records);
			})
		}

		descriptor.dataset = [];
		var ftr = bulk.initFilter(descriptor);
		console.log( 'ftr', ftr )
		descriptor.progressiveLoad({
			start:0, 
			filter: ftr,
		}, () => {
			bulk.init(descriptor)
		})

        // window.post('bulk_tasks', {bulkProject: descriptor.bulkProject, match:match}, res => {
		// 	console.log( 'BULK', res )
		// 	descriptor.filterData = res.data.filter;
		// 	descriptor.dataset = res.data.tasks;
		// 	if( descriptor.dataset.length == 0 ) return error( 'No documents found' )
		// 	descriptor.labels = [];
		// 	for( var k in res.data.labels ) {
		// 		var l = res.data.labels[k]
		// 		descriptor.labels.push({ label: l.name || k });
		// 	}
		// 	// console.log( 'descriptor', descriptor )
		// 	if( res.data.training ) {
		// 		descriptor.qualificationMode = res.data.training.type;
		// 		descriptor.qualificationFiles = res.data.training.files;
		// 		if( descriptor.qualificationMode == 3 ) {
		// 			descriptor.gridLayout.toggleDetails = descriptor.imageLayout.showDetails = false;
		// 		}
		// 	}
		// 	if( res.data.bookmarkURL ) {
		// 		descriptor.bookmarkURL = res.data.bookmarkURL;
		// 	}
		// 	descriptor.acknowledge = res.data.acknowledge || {};
		// 	descriptor.acknowledgeKey = projectId;
		// 	bulk.init(descriptor)
		// 	frm.loadingOut();
        // } )
    }

    useEffect( start );

	return (
		<>
			<div fluid="md p-0" className="imgcls-main maincontent">
				<div className="imgcls-toolbar hidden">
					<div className="imgcls-toolbar-commands"></div>
					<div className="imgcls-toolbar-filters"></div>
					<div className="imgcls-toolbar-sort"></div>
					<div className="imgcls-toolbar-tabs"></div>
					<div className="imgcls-toolbar-controls">
						<div className="imgcls-toolbar-sliders"></div>
						<div className="imgcls-toolbar-nav-placeholder"></div>
						<div className="imgcls-toolbar-nav"></div>
						<div className="imgcls-toolbar-buttons-placeholder"></div>
						<div className="imgcls-toolbar-buttons">
							<span className="selected-images"></span>
						</div>
					</div>
				</div>
				<div className="imgcls-browse">
				</div>
			</div>
		</>
	)
}

export default BulkClassify;
